<mat-card class="cardWithShadow">

    <mat-card-content>
        <!-- Search Field -->
        <div class="filter-controls">
            <mat-form-field appearance="outline" class="search-field">
                <mat-label>Search</mat-label>
                <input [formControl]="searchControl" matInput placeholder="Search objects">
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
        </div>

        @if ((betaBackendUnavailable$ | async) && objectType === 'chatbots') {
            <div class="beta-unavailable-state" data-testid="beta-backend-unavailable">
                <div class="beta-unavailable-icon" aria-hidden="true">
                    <mat-icon>cloud_off</mat-icon>
                </div>
                <div class="beta-unavailable-copy">
                    <p class="beta-unavailable-eyebrow">Beta unavailable</p>
                    <h2>Chatbots are temporarily unavailable</h2>
                    <p>
                        We could not load the beta chatbot list right now. The backend may still be waking up,
                        updating, or temporarily unreachable. Nothing was changed.
                    </p>
                </div>
                <div class="beta-unavailable-actions">
                    <button (click)="reloadPage()" color="primary" mat-flat-button>
                        Reload page
                    </button>
                    <button routerLink="/ai/dashboard" mat-stroked-button>
                        Go to dashboard
                    </button>
                </div>
            </div>
        } @else if (items$ | async; as items) {
            <div class="table-responsive m-t-30">
                <table [dataSource]="filteredItems" class="w-100" mat-table>
                    <!-- Select Column -->
                    @if (isSelectionMode) {
                        <ng-container matColumnDef="select">
                            <th *matHeaderCellDef class="f-w-600 f-s-14 mat-subtitle-1 p-l-0" mat-header-cell>
                                <mat-checkbox
                                        (change)="masterToggle(items)"
                                        [checked]="isAllSelected(items)"
                                        [indeterminate]="selection.hasValue() && !isAllSelected(items)">
                                </mat-checkbox>
                            </th>
                            <td *matCellDef="let element" class="p-l-0" mat-cell>
                                <mat-checkbox
                                        (change)="toggleSelection(element)"
                                        (click)="$event.stopPropagation()"
                                        [checked]="selection.isSelected(element.id)"
                                        [disabled]="isSelectionDisallowed(element)"
                                        [matTooltip]="(objectType === 'files' && element?.enabled === false) ? 'File is disabled' : ''">
                                </mat-checkbox>
                            </td>
                        </ng-container>
                    }
                    <!-- Name Column -->
                    <ng-container matColumnDef="name">
                        <th *matHeaderCellDef class="f-w-600 f-s-14 mat-subtitle-1 p-l-0" mat-header-cell>
                            Name
                        </th>
                        <td *matCellDef="let element" class="p-l-0 name-cell column-cell column-cell--primary" mat-cell>
                            <div class="d-flex name-cell-content">
                                <img [src]="getListingThumbnailImage(element)"
                                     alt=""
                                     aria-hidden="true"
                                     class="listing-thumbnail rounded"
                                     height="48"
                                     width="48"/>
                                <div class="m-l-16 listing-text">
                                    <h6 class="f-s-14 mat-subtitle-1 f-w-600 listing-title">
                                        {{ element?.name }}
                                    </h6>
                                    <span class="mat-body-1 f-s-12 listing-description">
                    {{ element?.description }}
                  </span>
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <!-- URL Column -->
                    <ng-container matColumnDef="url">
                        <th *matHeaderCellDef class="f-w-600 f-s-14 mat-subtitle-1" mat-header-cell>
                            URL
                        </th>
                        <td *matCellDef="let element" class="mat-body-1 column-cell column-cell--text" mat-cell>
              <span class="cell-text">
                {{ element.baseUrl }}
              </span>
                        </td>
                    </ng-container>
                    <!-- Description Column -->
                    <ng-container matColumnDef="description">
                        <th *matHeaderCellDef class="f-w-600 f-s-14 mat-subtitle-1" mat-header-cell>
                            Description
                        </th>
                        <td *matCellDef="let element" class="mat-body-1 column-cell column-cell--text" mat-cell>
              <span class="cell-text">
                {{ element.description | slice:0:50 }}
              </span>
                        </td>
                    </ng-container>
                    <!-- Status Column -->
                    <ng-container matColumnDef="status">
                        <th *matHeaderCellDef class="f-w-600 f-s-14 mat-subtitle-1" mat-header-cell>
                            Status
                        </th>
                        <td *matCellDef="let element" class="column-cell column-cell--badge" mat-cell>
                            @if (objectType === 'product-feeds' && element.sourceFeedId) {
                                <span class="bg-light-primary text-primary rounded f-w-600 p-6 p-y-4 f-s-12">
                  Root-owned
                </span>
                            } @else if (element.enabled) {
                                <span class="bg-light-success text-success rounded f-w-600 p-6 p-y-4 f-s-12">
                  {{ 'enabled' | titlecase }}
                </span>
                            } @else {
                                <span class="bg-light-error text-error rounded f-w-600 p-6 p-y-4 f-s-12">
                  {{ 'disabled' | titlecase }}
                </span>
                            }
                        </td>
                    </ng-container>
                    <!-- Schedule Column -->
                    <ng-container matColumnDef="schedule">
                        <th *matHeaderCellDef class="f-w-600 f-s-14 mat-subtitle-1" mat-header-cell>
                            Schedule
                        </th>
                        <td *matCellDef="let element" class="column-cell column-cell--badge" mat-cell>
                            @if (element.scheduleSettings?.scheduleEnabled) {
                                <span class="bg-light-success text-success rounded f-w-600 p-6 p-y-4 f-s-12">
                  {{ 'enabled' | titlecase }}
                </span>
                            } @else {
                                <span class="bg-light-error text-error rounded f-w-600 p-6 p-y-4 f-s-12">
                  {{ 'disabled' | titlecase }}
                </span>
                            }
                        </td>
                    </ng-container>
                    <!-- Notifications Column -->
                    <ng-container matColumnDef="notifications">
                        <th *matHeaderCellDef class="f-w-600 f-s-14 mat-subtitle-1" mat-header-cell>
                            Notifications
                        </th>
                        <td *matCellDef="let element" class="column-cell column-cell--badge" mat-cell>
                            @if (element.notificationSettings?.emailNotificationsEnabled || element.notificationSettings?.webhookNotificationsEnabled) {
                                <span class="bg-light-success text-success rounded f-w-600 p-6 p-y-4 f-s-12">
                  {{ 'enabled' | titlecase }}
                </span>
                            } @else {
                                <span class="bg-light-error text-error rounded f-w-600 p-6 p-y-4 f-s-12">
                  {{ 'disabled' | titlecase }}
                </span>
                            }
                        </td>
                    </ng-container>
                    <!-- Model Column -->
                    <ng-container matColumnDef="model">
                        <th *matHeaderCellDef class="f-w-600 f-s-14 mat-subtitle-1" mat-header-cell>
                            Model
                        </th>
                        <td *matCellDef="let element" class="mat-body-1 column-cell column-cell--text" mat-cell>
              <span class="cell-text">
                {{ element.model }}
              </span>
                        </td>
                    </ng-container>
                    <!-- Type Column -->
                    <ng-container matColumnDef="type">
                        <th *matHeaderCellDef class="f-w-600 f-s-14 mat-subtitle-1" mat-header-cell>
                            Type
                        </th>
                        <td *matCellDef="let element" class="mat-body-1 column-cell column-cell--text" mat-cell>
              <span class="cell-text">
                {{ element.type }}
              </span>
                        </td>
                    </ng-container>
                    <!-- Product Feed Market Column -->
                    <ng-container matColumnDef="market">
                        <th *matHeaderCellDef class="f-w-600 f-s-14 mat-subtitle-1" mat-header-cell>
                            Market
                        </th>
                        <td *matCellDef="let element" class="mat-body-1 column-cell column-cell--text" mat-cell>
                            <span class="cell-text">{{ element.market || 'Not set' }}</span>
                        </td>
                    </ng-container>
                    <!-- Product Feed Graph Role Column -->
                    <ng-container matColumnDef="graphRole">
                        <th *matHeaderCellDef class="f-w-600 f-s-14 mat-subtitle-1" mat-header-cell>
                            Graph role
                        </th>
                        <td *matCellDef="let element" class="mat-body-1 column-cell column-cell--text" mat-cell>
                            <span class="cell-text">{{ productFeedGraphRole(element) }}</span>
                        </td>
                    </ng-container>
                    <!-- Product Feed Index State Column -->
                    <ng-container matColumnDef="indexState">
                        <th *matHeaderCellDef class="f-w-600 f-s-14 mat-subtitle-1" mat-header-cell>
                            Index
                        </th>
                        <td *matCellDef="let element" class="mat-body-1 column-cell column-cell--text" mat-cell>
                            <span class="cell-text f-w-600">{{ productFeedIndexState(element) }}</span>
                            <span class="cell-detail">
                                @if (productFeedIndexedProductCount(element); as productCount) {
                                    {{ productCount }} indexed products
                                } @else if (productFeedIndexedProductCount(element) === 0) {
                                    0 indexed products
                                } @else {
                                    Product count unavailable
                                }
                            </span>
                        </td>
                    </ng-container>
                    <!-- Product Feed Publication and Fetch Column -->
                    <ng-container matColumnDef="lastActivity">
                        <th *matHeaderCellDef class="f-w-600 f-s-14 mat-subtitle-1" mat-header-cell>
                            Last activity
                        </th>
                        <td *matCellDef="let element" class="mat-body-1 column-cell column-cell--text" mat-cell>
                            <span class="cell-text">
                                <span class="f-w-600">Published:</span>
                                {{ productFeedPublicationDate(element) ? (productFeedPublicationDate(element) | date:'short') : 'Never' }}
                                @if (productFeedUsesRootPublication(element)) { (root feed) }
                            </span>
                            <span class="cell-detail">
                                <span class="f-w-600">Fetched:</span>
                                {{ productFeedFetchDate(element) ? (productFeedFetchDate(element) | date:'short') : 'Never' }}
                                @if (productFeedUsesRootPublication(element)) { (root feed) }
                            </span>
                        </td>
                    </ng-container>
                    <!-- File Type Column -->
                    <ng-container matColumnDef="filetype">
                        <th *matHeaderCellDef class="f-w-600 f-s-14 mat-subtitle-1" mat-header-cell>
                            File Type
                        </th>
                        <td *matCellDef="let element" class="mat-body-1 column-cell column-cell--icon" mat-cell>
                            <i-tabler [name]="matchFileTypeWithTablerIcons(element.fileName)" class="routeIcon"
                                      matListItemIcon></i-tabler>
                        </td>
                    </ng-container>
                    <!-- Actions Column -->
                    <ng-container matColumnDef="actions">
                        <th *matHeaderCellDef class="f-w-600 f-s-14 mat-subtitle-1" mat-header-cell>
                            Actions
                        </th>
                        <td *matCellDef="let element" class="mat-body-1 column-cell column-cell--action" mat-cell>
                            <div class="row-actions">
                                <button [routerLink]="[element.id]"
                                        aria-label="Edit {{ element?.name }}"
                                        mat-icon-button
                                        matTooltip="Edit">
                                    <i-tabler class="routeIcon" name="edit"></i-tabler>
                                </button>
                                @if (canDuplicate()) {
                                    <button (click)="duplicateObject(element, $event)"
                                            aria-label="Duplicate {{ element?.name }}"
                                            mat-icon-button
                                            matTooltip="Duplicate">
                                        <mat-icon>content_copy</mat-icon>
                                    </button>
                                }
                            </div>
                        </td>
                    </ng-container>
                    <!-- Header and Row Definitions -->
                    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
                    <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
                </table>
            </div>
        }
    </mat-card-content>
</mat-card>
@if (objectType) {
    <div class="d-flex" style="flex-direction: row; padding: 0 24px;">
        @if (!isSelectionMode) {
            <button (click)="openCreateDialog()" color="primary" extended mat-fab matTooltip="Add new {{objectType}}">
        <mat-icon>add</mat-icon> Add {{objectType}}
            </button>
        }
    </div>
}
